var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-reply-preview d-flex align-center rounded",
      class: { "chat-reply-preview--compact": _vm.compact },
      attrs: { "data-test": "reply-preview" },
      on: { click: _vm.onClick }
    },
    [
      _c("div", { staticClass: "chat-reply-preview__bar" }),
      _c(
        "div",
        {
          staticClass: "chat-reply-preview__content flex-grow-1 overflow-hidden"
        },
        [
          _vm.senderName
            ? _c(
                "div",
                {
                  staticClass:
                    "chat-reply-preview__sender text-caption font-weight-medium"
                },
                [_vm._v(" " + _vm._s(_vm.senderName) + " ")]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "chat-reply-preview__text text-caption grey--text text-truncate"
            },
            [_vm._v(" " + _vm._s(_vm.truncatedContent || "Mensagem") + " ")]
          )
        ]
      ),
      _vm.showCancel
        ? _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: {
                icon: "",
                small: "",
                "data-test": "reply-cancel",
                "aria-label": "Cancelar resposta"
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.onCancel($event)
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: { name: _vm.icons.close, size: "12", color: "#8E8E8E" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }